import { render, staticRenderFns } from "./CustomPageMake.vue?vue&type=template&id=780406bf&scoped=true&"
import script from "./CustomPageMake.vue?vue&type=script&lang=js&"
export * from "./CustomPageMake.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageMake.vue?vue&type=style&index=0&id=780406bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780406bf",
  null
  
)

export default component.exports